import { InvestmentPackage } from "@/api/type";
import { API_URL, API_USER_URL } from "@/env";
import { mixGetV1 } from "@/services/mixin";

type AffiliateMember = {
    id: string | number;
    fullname: string;
    email: string;
    phone?: string | null;
    join_date?: string;
    birthday?: string | null;
    total_packages?: number;
    total_invested?: string;
    total_revenue?: string;
    kyc_status?: boolean;
    deposit_status?: boolean;
    referral_code?: string;
    action_link?: string;
    packages_detail: {
        package_name: string;
        quantity: number;
        total_amount: string;
    }[];
    user_info?: {
        id: number;
        fullname: string;
        email: string;
        avatar: string | null;
        phone: string | null;
        gender: string | null;
        birthday: string | null;
        job_title: string | null;
    };

};

type UserInfo = {
    id: number;
    fullname: string;
    email: string;
    avatar: string | null;
    phone: string | null;
    gender: string | null;
    birthday: string | null;
    job_title: string | null;
};

const API_USE = API_URL || '';

async function fetchAffiliateMembers(page: number, pageSize: number, search: string): Promise<{ data: {data: AffiliateMember[]; total: number} }> {
    try {
        const response = await fetch(API_USE + `/api/v1/be/affiliate/members?page=${page}&per_page=${pageSize}${search ? `&keyword=${search}` : ''}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
            }
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return {
            data: {
                data: result.data.data || [],
                total: result.data.total || 0,
            }
        };

    }
    catch (error) {
        console.error('Error fetching affiliate members:', error);
        return {
            data: {
                data: [],
                total: 0,
            }
        };
    }
}

async function getDetailsMember(memberId: string): Promise<{
    data: InvestmentPackage[]
} | null> {
    try {
        const response = await fetch(API_USE + `/api/v1/be/user-packages/${memberId}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
            }
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return {
            data: result.data || []
        }
    } catch (error) {
        console.error('Error fetching member details:', error);
        return null;
    }
}

export { fetchAffiliateMembers, getDetailsMember };